module.exports = __webpack_public_path__ + "fonts/Montserrat-BoldItalic.781190a.ttf";